/**
 * Ministry of Buzz — Buzz Box Bundle Manager
 * File: assets/buzz-box-bundle.js
 * Loaded globally through theme.liquid
 *
 * Responsibilities:
 * 1. Detect component lines whose Buzz Box parent was removed.
 * 2. Remove those orphaned component lines together.
 * 3. Refresh the Shapes cart sections.
 * 4. Correct the customer-facing Alpine cart count.
 *
 * No polling.
 * No MutationObserver.
 */

(function () {
  'use strict';

  var CART_ROOT =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  var cleanupInProgress = false;

  function getCartUrl(endpoint) {
    return CART_ROOT + endpoint;
  }

  function isBundleComponent(item) {
    return Boolean(
      item.properties &&
      item.properties._bundle_role === 'component'
    );
  }

  function isBundleParent(item) {
    return Boolean(
      item.properties &&
      item.properties._bundle_role === 'parent'
    );
  }

  function updateVisibleCount(cartItems) {
    var visibleCount = cartItems.reduce(function (count, item) {
      if (isBundleComponent(item)) {
        return count;
      }

      return count + item.quantity;
    }, 0);

    if (window.Alpine) {
      try {
        var cartCountStore = Alpine.store('cart_count');

        if (cartCountStore) {
          cartCountStore.count = visibleCount;
        }
      } catch (error) {
        console.warn(
          '[BuzzBox] Could not update Alpine cart count:',
          error
        );
      }
    }

    if (window.theme) {
      window.theme.cartItemCount = visibleCount;
    }

    console.log(
      '[BuzzBox] Visible cart count:',
      visibleCount
    );
  }

  function fetchCurrentCart() {
    return fetch(getCartUrl('cart.js'), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Could not load the current cart.');
      }

      return response.json();
    });
  }

  function findOrphanedComponentKeys(cartItems) {
    var activeBundleIds = cartItems
      .filter(isBundleParent)
      .map(function (item) {
        return item.properties._bundle_id;
      })
      .filter(Boolean);

    return cartItems
      .filter(function (item) {
        if (!isBundleComponent(item)) {
          return false;
        }

        var bundleId = item.properties._bundle_id;

        return (
          bundleId &&
          activeBundleIds.indexOf(bundleId) === -1
        );
      })
      .map(function (item) {
        return item.key;
      });
  }

  function removeOrphanedComponents(orphanedKeys) {
    var updates = {};

    orphanedKeys.forEach(function (key) {
      updates[key] = 0;
    });

    return fetch(getCartUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: updates,
        sections:
          'cart-items,cart-footer,cart-item-count,cart-live-region',
        sections_url: '/collections/all'
      })
    })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Could not remove Buzz Box components.'
          );
        }

        return data;
      });
    });
  }

  function refreshShapesCart(cartResponse) {
    if (
      !cartResponse.sections ||
      !cartResponse.sections['cart-items'] ||
      !cartResponse.sections['cart-footer'] ||
      !cartResponse.sections['cart-item-count'] ||
      !cartResponse.sections['cart-live-region']
    ) {
      console.warn(
        '[BuzzBox] Cart updated, but one or more Shapes sections were not returned.',
        cartResponse.sections
      );

      return;
    }

    document.body.dispatchEvent(
      new CustomEvent('shapes:cart:update', {
        bubbles: true,
        detail: {
          response: cartResponse
        }
      })
    );
  }

  function cleanupOrphanedComponents() {
    if (cleanupInProgress) {
      return;
    }

    cleanupInProgress = true;

    fetchCurrentCart()
      .then(function (cart) {
        var orphanedKeys =
          findOrphanedComponentKeys(cart.items);

        if (!orphanedKeys.length) {
          updateVisibleCount(cart.items);
          return null;
        }

        console.log(
          '[BuzzBox] Removing orphaned component lines:',
          orphanedKeys
        );

        return removeOrphanedComponents(orphanedKeys);
      })
      .then(function (updatedCart) {
        if (!updatedCart) {
          return;
        }

        updateVisibleCount(updatedCart.items);
        refreshShapesCart(updatedCart);
      })
      .catch(function (error) {
        console.warn(
          '[BuzzBox] Bundle cleanup failed:',
          error
        );
      })
      .finally(function () {
        cleanupInProgress = false;
      });
  }

  /*
   * Shapes dispatches these after an Ajax add or quantity/removal change.
   */
  window.addEventListener(
    'shapes:cart:afteradditem',
    cleanupOrphanedComponents
  );

  window.addEventListener(
    'shapes:cart:cartqtychange',
    cleanupOrphanedComponents
  );

  /*
   * Also run once after page load to clean up components
   * left from an interrupted or older cart session.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      cleanupOrphanedComponents
    );
  } else {
    cleanupOrphanedComponents();
  }
// Intercept Add to Cart for Buzz Box on collection/home pages
  document.addEventListener('click', function(e) {
    if (window.location.pathname.indexOf('buzz-box') !== -1) return;
    
    var btn = e.target.closest('button[type="submit"]');
    if (!btn) return;
    
    var form = btn.closest('form');
    if (!form) return;
    
    var variantInput = form.querySelector('input[name="id"][value="51974146425128"]');
    if (!variantInput) return;
    
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/products/buzz-box';
  }, true); // true = capture phase, fires before Shapes handles it
  
})();